import ready from './util/ready';
import {createApp} from 'vue';
import BlockLocations from './vue/BlockLocations';

ready(() => {
  const locationsBlock = document.getElementsByClassName('block-locations-map-app');
  if (locationsBlock.length > 0) {
    const locationsBlockId = locationsBlock[0].id;

    createApp(BlockLocations, {
      rawItems: locationsBlock[0].getAttribute('data-items'),
    }).mount('#' + locationsBlockId);
  }
});
